import React from 'react'
import { connect } from "react-redux"
import Ajax from 'superagent'
import { Home as HomeIcon, MapPin } from 'react-feather'

import { 
  Button,
  CellsTitle,
  CellBody,
  Form,
  FormCell,
  TextArea
} from 'react-weui'

import { push } from 'connected-react-router'
import ReactMarkdown from 'react-markdown'


import Page from "../components/FixedBarPage"
import './FutbolPage.less'
import PersonalForm from '../components/PersonalForm'

const Description = `当前赛季已结束，下赛季球赛在8月18日重新开启。

留下您的联系方式以便我们可以及时通知您球赛的具体日期及价格。
`

class FutbolPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      name: "",
      prefix: "+86",
      phone: "",
      wechat: "",
      comment: "",
    }
  }

  submit() {
    this.props.push(`/catalogo/futbol/confirmation`)

    Ajax.post("/addreservation")
      .send({
        name: this.state.name, 
        prefix: this.state.prefix, 
        phone: this.state.phone, 
        type: "futbol_request",
        comment: this.state.comment, 
      })
      .then((res) => {
        this.props.updateUserData({ 
          name: this.state.name, 
          prefix: this.state.prefix, 
          phone: this.state.phone, 
        })

        window.location = `/payment?id=${res.body.id}&price=${eurPrice}&vendor=${this.props.userInfo.vendor}`
      })
  }

  render() {
    return (
      <Page
        title="足球"
        footer={
          <Button 
            style={{width: "100%", marginTop: 0}} 
            onClick={() => this.submit()}
            disabled={!this.state.name || !this.state.phone}
          >
            提交
          </Button>
        }
        containerProps={{
          id: "FutbolPage",
          style: { backgroundImage: `url(/static/img/gridImages/futbolbackground.jpg)` }
        }}
      >
        <div className="scrolly">

          <div className="main">
            <ReactMarkdown source={Description} />
          </div>
          
          <div className="rest orange-bg">
            <div className="longdescription">
              <PersonalForm
                name={this.state.name}
                prefix={this.state.prefix}
                phone={this.state.phone}
                wechat={this.state.wechat}

                onName={name =>     this.setState({ name,   })}
                onPrefix={prefix => this.setState({ prefix, })}
                onPhone={phone =>   this.setState({ phone,  })}
                onWechat={wechat => this.setState({ wechat, })}
              />

              <CellsTitle>需求</CellsTitle>
              <Form>
                <FormCell>
                  <CellBody>
                    <TextArea 
                      placeholder="在这里留下您对想看球赛的需求。例如，想要什么时候来看球; 想看哪个球队的球赛等。" 
                      rows="3" 
                      maxLength="200"
                      onChange={evt => this.setState({comment: evt.target.value})}
                    />
                  </CellBody>
                </FormCell>
              </Form>
            </div>
          </div>
        
        </div>  
      </Page>
    )
  }
}

const mapDispatchToProps = dispatch => ({ 
  push: url => dispatch(push(url)),
})

const mapStateToProps = () => ({ })

export default connect(mapStateToProps, mapDispatchToProps)(FutbolPage);

/**
 *   
 * 
 */



// WEBPACK FOOTER //
// ./src/app/catalogo/futbol/FutbolPage.jsx